import React, { useEffect, useState } from "react";
import Select from "react-select";
import Header from "../../../components/Header";
import LoadingOverlay from "../../../components/LoadingOverlay";
import ReportFiltersCard, {
    ReportFilterField,
} from "../../../components/reports/ReportFiltersCard";
import Sidebar from "../../../components/Sidebar";
import { getJobsByStatuses } from "../../../services/analytics/geJobsByStatuses";
import { getServicesByStatuses } from "../../../services/analytics/getServicesByStatuses";
import { getSubscriptionYears } from "../../../services/analytics/getSubscriptionYears";
import { getEmployees } from "../../../services/getEmployees";
import { getServices } from "../../../services/getServices";
import { getServiceDepartments } from "../../../services/service/getServiceDepartments";
import JobStatusReportTable from "./components/JobStatusReportTable";
import ServiceStatusReportTable from "./components/ServiceStatusReportTable";

const DEFAULT_ID = "00000000-0000-0000-0000-000000000000";

const SERVICE_ASSIGNMENTS = [
    {
        value: "services",
        label: "Services",
        is_showing: true,
    },
    {
        value: "jobs",
        label: "Steps",
        is_showing: false,
    },
];

const INITIALIZE_DROPDOWNS = [
    {
        value: DEFAULT_ID,
        label: "All",
        is_showing: true,
    },
];

const StatusReport = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [clientSubcriptionByStatuses, setClientSubcriptionByStatuses] = useState(
        [],
    );

    const [jobsByStatusesReport, setJobsByStatusesReport] = useState([]);
    const currentTaxYear = new Date().getFullYear();
    const [years, setYears] = useState([
        { name: currentTaxYear, year: currentTaxYear },
    ]);
    const [departments, setDepartments] = useState(INITIALIZE_DROPDOWNS);
    const [employees, setEmployees] = useState(INITIALIZE_DROPDOWNS);
    const [services, setServices] = useState(INITIALIZE_DROPDOWNS);
    const [filters, setFilters] = useState({
        assignmentValue: SERVICE_ASSIGNMENTS[0].value,
        serviceId: DEFAULT_ID,
        employeeId: DEFAULT_ID,
        departmentId: DEFAULT_ID,
        year: currentTaxYear,
    });
    const [appliedFilters, setAppliedFilters] = useState({
        assignmentValue: SERVICE_ASSIGNMENTS[0].value,
        serviceId: DEFAULT_ID,
        employeeId: DEFAULT_ID,
        departmentId: DEFAULT_ID,
        year: currentTaxYear,
    });
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState("");
    const resultsSectionRef = React.useRef(null);
    const shouldScrollToResultsRef = React.useRef(false);

    useEffect(() => {
        fetchDepartments();
        fetchEmployees();
        getNewServices();
        getDifferentSubscriptionYears();
    }, []);

    useEffect(() => {
        fetchStatusReport();
    }, [appliedFilters]);

    const getServiceStatusReport = async (
        year,
        employeeId = DEFAULT_ID,
        departmentId = DEFAULT_ID,
        serviceId = DEFAULT_ID,
    ) => {
        const response = await getServicesByStatuses(
            year,
            employeeId,
            departmentId,
            serviceId,
        );
        if (response.success) {
            setClientSubcriptionByStatuses(
                response.data.clientSubcriptionByStatuses,
            );
        } else {
            console.log(response);
        }
    };

    const getJobStatusReport = async (
        year,
        employeeId = DEFAULT_ID,
        departmentId = DEFAULT_ID,
        serviceId = DEFAULT_ID,
    ) => {
        const response = await getJobsByStatuses(
            year,
            employeeId,
            departmentId,
            serviceId,
        );
        if (response.success) {
            setJobsByStatusesReport(response.data.jobs);
        } else {
            console.log(response);
        }
    };

    const fetchDepartments = async () => {
        const response = await getServiceDepartments();
        const departmentsArray = [];
        if (response.data.success) {
            response.data.departments.map((department) => {
                departmentsArray.push({
                    value: department.id,
                    label: department.name,
                    is_showing: true,
                });
            });
            setDepartments([INITIALIZE_DROPDOWNS[0], ...departmentsArray]);
        }
        console.log(response);
    };

    const getNewServices = async () => {
        //get service status names
        const response = await getServices();

        const servicesArray = [];
        if (response.success) {
            response.data.map((service) => {
                servicesArray.push({
                    value: service.id,
                    label: service.name,
                    is_showing: true,
                });
            });
            setServices([INITIALIZE_DROPDOWNS[0], ...servicesArray]);
        }
    };

    async function fetchEmployees() {
        Promise.all([getEmployees()]).then((res) => {
            let data = res[0].data.employees;
            console.log(data);
            const arr = [];
            // eslint-disable-next-line
            data.map((emp, i) => {
                arr.push({
                    value: emp.employeeId,
                    label: `${emp.firstName} ${emp.lastName}`,
                    is_showing: true,
                });
                if (arr.length > 0) {
                    let tmp = [INITIALIZE_DROPDOWNS[0], ...arr];
                    setEmployees(tmp);
                }
            });
        });
    }

    const getDifferentSubscriptionYears = async () => {
        const response = await getSubscriptionYears();
        if (response.success) {
            let newYears = [];
            response.data.years.map((year) => {
                newYears.push({ name: year, year: year });
            });
            newYears.push({ name: "All", year: 0 });
            setYears(newYears);
        } else {
            console.log(response);
        }
    };

    const onChangeSelectedDepartment = (department) => {
        setFilters((currentFilters) => ({
            ...currentFilters,
            departmentId: department?.value || DEFAULT_ID,
        }));
    };

    const onChangeSelecetedEmployee = (employee) => {
        setFilters((currentFilters) => ({
            ...currentFilters,
            employeeId: employee?.value || DEFAULT_ID,
        }));
    };

    const onChangeSelectedService = (service) => {
        setFilters((currentFilters) => ({
            ...currentFilters,
            serviceId: service?.value || DEFAULT_ID,
        }));
    };

    const onChangeSelectedAssignment = (assignment) => {
        setFilters((currentFilters) => ({
            ...currentFilters,
            assignmentValue: assignment?.value || SERVICE_ASSIGNMENTS[0].value,
        }));
    };

    const onHandleChangeYear = (option) => {
        setFilters((currentFilters) => ({
            ...currentFilters,
            year: option?.year ?? currentTaxYear,
        }));
    };

    const fetchStatusReport = async () => {
        setIsLoading(true);
        setError("");

        try {
            if (appliedFilters.assignmentValue === "jobs") {
                await getJobStatusReport(
                    appliedFilters.year,
                    appliedFilters.employeeId,
                    appliedFilters.departmentId,
                    appliedFilters.serviceId,
                );
            } else {
                await getServiceStatusReport(
                    appliedFilters.year,
                    appliedFilters.employeeId,
                    appliedFilters.departmentId,
                    appliedFilters.serviceId,
                );
            }
        } catch (fetchError) {
            setError(fetchError.message || "Error loading status report.");
        } finally {
            setIsLoading(false);
        }
    };

    const handleApplyFilters = () => {
        shouldScrollToResultsRef.current = true;
        setAppliedFilters({ ...filters });
    };

    useEffect(() => {
        if (isLoading || !shouldScrollToResultsRef.current) {
            return;
        }

        if (resultsSectionRef.current) {
            resultsSectionRef.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }

        shouldScrollToResultsRef.current = false;
    }, [clientSubcriptionByStatuses, jobsByStatusesReport, isLoading]);

    const selectedAssignment =
        SERVICE_ASSIGNMENTS.find(
            (assignment) => assignment.value === filters.assignmentValue,
        ) || SERVICE_ASSIGNMENTS[0];
    const appliedAssignment =
        SERVICE_ASSIGNMENTS.find(
            (assignment) => assignment.value === appliedFilters.assignmentValue,
        ) || SERVICE_ASSIGNMENTS[0];
    const selectedService =
        services.find((service) => service.value === filters.serviceId) ||
        services[0] ||
        INITIALIZE_DROPDOWNS[0];
    const selectedEmployee =
        employees.find((employee) => employee.value === filters.employeeId) ||
        employees[0] ||
        INITIALIZE_DROPDOWNS[0];
    const selectedDepartment =
        departments.find(
            (department) => department.value === filters.departmentId,
        ) ||
        departments[0] ||
        INITIALIZE_DROPDOWNS[0];
    const selectedYear =
        years.find((yearOption) => yearOption.year === filters.year) || years[0];

    return (
        <section>
            <LoadingOverlay isLoading={isLoading} />
            <div className="flex h-screen overflow-hidden">
                <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

                <div className="relative flex flex-col flex-1 overflow-x-hidden overflow-y-auto">
                    <Header
                        sidebarOpen={sidebarOpen}
                        setSidebarOpen={setSidebarOpen}
                    />

                    <main>
                        <div className="w-full px-4 py-8 mx-auto sm:px-6 lg:px-8 max-w-9xl">
                            <div className="flex flex-col items-start max-w-3xl">
                                <h1 className="text-2xl font-bold md:text-3xl text-slate-800">
                                    Status {selectedYear && selectedYear.name}
                                </h1>
                            </div>

                            <ReportFiltersCard
                                actions={
                                    <button
                                        type="button"
                                        onClick={handleApplyFilters}
                                        disabled={isLoading}
                                        className="inline-flex items-center px-4 py-2 text-sm font-medium text-white transition bg-teal-500 rounded-lg shadow-sm hover:bg-teal-600 disabled:cursor-not-allowed disabled:opacity-60"
                                    >
                                        Apply Filters
                                    </button>
                                }
                                fieldsClassName="grid grid-cols-1 gap-4 xl:grid-cols-6"
                            >
                                <ReportFilterField label="Assignment Type">
                                    <Select
                                        onChange={(e) => onChangeSelectedAssignment(e)}
                                        classNamePrefix="select"
                                        isSearchable={false}
                                        value={selectedAssignment}
                                        options={SERVICE_ASSIGNMENTS}
                                        name="assignment"
                                        isDisabled={isLoading}
                                    />
                                </ReportFilterField>

                                <ReportFilterField label="Service">
                                    <Select
                                        onChange={(e) => onChangeSelectedService(e)}
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        value={selectedService}
                                        options={services}
                                        name="services"
                                        isDisabled={isLoading}
                                    />
                                </ReportFilterField>

                                <ReportFilterField label="Employee">
                                    <Select
                                        onChange={(e) => onChangeSelecetedEmployee(e)}
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        value={selectedEmployee}
                                        options={employees}
                                        name="employee"
                                        isDisabled={isLoading}
                                    />
                                </ReportFilterField>

                                <ReportFilterField label="Department">
                                    <Select
                                        onChange={(e) => onChangeSelectedDepartment(e)}
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        value={selectedDepartment}
                                        options={departments}
                                        name="departments"
                                        isDisabled={isLoading}
                                    />
                                </ReportFilterField>

                                <ReportFilterField label="Year">
                                    <Select
                                        onChange={(option) => onHandleChangeYear(option)}
                                        classNamePrefix="select"
                                        isSearchable={false}
                                        value={selectedYear}
                                        options={years}
                                        getOptionLabel={(option) => String(option.name)}
                                        getOptionValue={(option) => String(option.year)}
                                        isDisabled={isLoading}
                                    />
                                </ReportFilterField>
                            </ReportFiltersCard>

                            {error && (
                                <div className="p-3 mt-6 text-sm text-red-700 border border-red-200 rounded-lg shadow-sm bg-red-50">
                                    {error}
                                </div>
                            )}
                        </div>

                        <div ref={resultsSectionRef} className="mt-6">
                            {appliedAssignment.label === "Services" && (
                                <ServiceStatusReportTable
                                    assignments={clientSubcriptionByStatuses}
                                />
                            )}
                            {appliedAssignment.label === "Jobs" && (
                                <JobStatusReportTable jobs={jobsByStatusesReport} />
                            )}
                        </div>
                    </main>
                </div>
            </div>
        </section>
    );
};
export default StatusReport;
